import React from 'react';
import { Card } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.css';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import { Clear, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category, Add, Star } from '@material-ui/icons';
import DashboardLineChart from '../../components/Chart/DashboardLineChart';
import { withTheme, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import HOCSectionLoader from '../../components/HOC/HOCSectionLoader.jsx';

import { compose } from 'redux';
import { Route, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import BookingList from '../../components/Providers/BookingList';
import { NotificationManager } from 'react-notifications';
import { getCookies } from '../../utils/getToken';
import Axios from 'axios';
import { SERVER_URL } from '../../utils/config/constants';
import Calendar from 'react-calendar';

const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};
const styles = theme => ({
    heading: {
        color: '#ffffff'
    },
    paper: {
        backgroundColor: theme.palette.primary.main
    },
    card: {
        color: theme.palette.secondary.main
    }
});
let isLoading = true;
class ProviderDashboardNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            requestedData: [],
            confirmedData: [],
            completedData: [],
            todaysBookingData: [],
            todaysBookingCount: 0,
            providerRating: 0
        };
    }
    componentDidMount() {
        this.getBookingSummaryData();
        this.getTodaysBookingData();
        this.getProviderRatings()
    }

    getBookingSummaryData = async () => {
        var authToken = getCookies();
        // var latitude = getLatitude();
        // var longitude = getLongitude();
        // console.log('latitude', latitude, 'longitude', longitude, );
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/booking/provider-owndata`,
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('manage bookings pro data', data);
            if (data.status == 'OK') {
                this.setState({
                    loading: false,
                    // bookingSummaryData: data.data, 
                    requestedData: data.data[0].requested,
                    confirmedData: data.data[1].confirmed,
                    completedData: data.data[3].completed,
                    //   completedData: data.data[4].completed
                })
            }
            else {
                this.setState({
                    loading: false
                })
            }
        } catch (error) {
            console.log("====================manage booking list ERRORRRRRR", error);
        }
    }

    getTodaysBookingData = async () => {
        var authToken = getCookies();
        // var latitude = getLatitude();
        // var longitude = getLongitude();
        // console.log('latitude', latitude, 'longitude', longitude, );
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/booking/today-booking`,
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('todays booking data', data);
            if (data.status == 'OK') {
                this.setState({
                    loading: false,
                    todaysBookingData: data.data,
                    todaysBookingCount: data.data.length
                })
            }
            else {
                this.setState({
                    loading: false
                })
            }
        } catch (error) {
            console.log("====================todays booking ERRORRRRRR", error);
        }
    }

    getProviderRatings = async () => {
        var authToken = getCookies();
        // var latitude = getLatitude();
        // var longitude = getLongitude();
        // console.log('latitude', latitude, 'longitude', longitude, );
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/booking/provider-rating`,
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('Provider RATING data', data);
            if (data.status == 'OK') {
                this.setState({
                    providerRating: data.data,
                })
            }
            else {
                this.setState({
                    loading: false
                })
            }
        } catch (error) {
            console.log("====================Provider RATING ERRORRRRRR", error);
        }
    }

    renderRatingZero = () => {
        return (

            <div style={{
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                {/* <Star name="star" size={24} color={'orange'} style={{marginLeft: 3}} /> */}
                <Star style={{ fontSize: 24, color: 'grey' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
            </div>

        )
    }

    renderRatingOne = () => {
        return (

            <div style={{
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
            </div>

        )
    }

    renderRatingTwo = () => {
        return (

            <div style={{
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
            </div>

        )
    }

    renderRatingThree = () => {
        return (

            <div style={{
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
            </div>

        )
    }

    renderRatingFour = () => {
        return (

            <div style={{
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'grey' }} />
            </div>

        )
    }

    renderRatingFive = () => {
        return (

            <div style={{
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'orange' }} />
                <Star style={{ fontSize: 24, color: 'orange' }} />
            </div>

        )
    }

    render() {
        var card = {
            border: '1px solid #eee',
            boxShadow: '1px 1px 20px #ddd',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            // backgroundColor: '#0078ff',
            // border: '1px solid #0078ff',
            padding: '20px 40px',
            margin: 10,
            borderRadius: 10,
            width: '50%',
        }

        var statusLengthCard = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#0078ff',
            padding: '20px 60px',
            margin: 10,
            borderRadius: 10,
            cursor: 'pointer'
        }
        return (
            <div className="tz-2-com tz-2-main">
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '0px 3rem',
                }}>
                    <h4>
                        <FormattedMessage
                            id="home"
                            defaultMessage="Home"
                        />
                    </h4>
                    <div
                        style={{
                            marginRight: '1rem',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems:'flex-end',
                            marginTop:'1rem'
                        }}
                    >
                        <p style={{
                            // color: 'white',
                            marginTop:'1rem',
                            fontSize: 18,
                            fontWeight: 'bold',
                        }}>Ratings ({this.state.providerRating})</p>
                        <div style={{
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            {this.state.providerRating === 0 ? this.renderRatingZero() : null}
                            {this.state.providerRating === 1 ? this.renderRatingOne() : null}
                            {this.state.providerRating === 2 ? this.renderRatingTwo() : null}
                            {this.state.providerRating === 3 ? this.renderRatingThree() : null}
                            {this.state.providerRating === 4 ? this.renderRatingFour() : null}
                            {this.state.providerRating === 5 ? this.renderRatingFive() : null}
                        </div>
                    </div>
                </div>
                <div>
                    <div
                    id='booking_details'
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop:'5vh'
                    }}>
                        <div
                            onClick={() => this.props.history.push('/provider/manage_bookings', { activeTab: 'Requested' })}
                            style={statusLengthCard}>
                            <p style={{
                                color: 'white',
                                fontSize: 40,
                                fontWeight: 'bold'
                            }}>{this.state.requestedData.length}</p>
                            <p style={{
                                color: 'white',
                                fontSize: 22
                            }}>Requested</p>
                        </div>
                        <div
                            onClick={() => this.props.history.push('/provider/manage_bookings', { activeTab: 'Confirmed' })}
                            style={statusLengthCard}>
                            <p style={{
                                color: 'white',
                                fontSize: 40,
                                fontWeight: 'bold'
                            }}>{this.state.confirmedData.length}</p>
                            <p style={{
                                color: 'white',
                                fontSize: 22
                            }}>Confirmed</p>
                        </div>
                        <div
                            onClick={() => this.props.history.push('/provider/manage_bookings', { activeTab: 'Completed' })}
                            style={statusLengthCard}>
                            <p style={{
                                color: 'white',
                                fontSize: 40,
                                fontWeight: 'bold'
                            }}>{this.state.completedData.length}</p>
                            <p style={{
                                color: 'white',
                                fontSize: 22
                            }}>Completed</p>
                        </div>
                    </div>
                    <div 
                    id='booking_details'
                    style={{
                        display:'flex',
                        justifyContent:'space-around',
                        marginTop:'5vh'
                    }}>
                    <div style={{
                        // display: 'flex',
                        // justifyContent: 'center',
                        // margin: '60px 0',
                        marginLeft: '10px'
                    }}>
                        <Calendar
                            style={{ 
                                height: "100vh", 
                                width: '75%', 
                                background: "#fff"
                            }}
                        />
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        margin: '60px 0',
                        // padding: '0 15rem',
                        // width: '100%',
                    }}>
                        <div
                            onClick={() => this.props.history.push('/provider/manage_todays_bookings')}
                            style={{ ...card, cursor: 'pointer', width: '100%' }}>
                            <p style={{
                                // color: 'white',
                                fontSize: 22,
                                fontWeight: 'bold'
                            }}>Bookings for Today</p>
                            <p style={{
                                // color: 'white',
                                fontSize: 40,
                                marginBottom: 0
                            }}>{this.state.todaysBookingCount ? this.state.todaysBookingCount : 0}</p>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}

// const mapStateToProps = ({ settings }) => {
//     return {
//         colors: settings.colors
//     };
// };
const composedComponent = compose(
    withStyles(styles),
    withTheme(),
    connect(
        null,
        actions
    )
);

export default withRouter(composedComponent(ProviderDashboardNew));



// WEBPACK FOOTER //
// ./src/views/ProviderScreensNew/ProviderDashboardNew.jsx